import React from "react";
import { getServerEndpoint } from "../../../../utils/serverEndpoint";
export const SchemaNonCompliant = [
  // {
  //   heights: { header1: "50px" },
  //   classes: { header2: "" },
  //   inlineData: true,
  //   columns: [
  //     {
  //       title: "LOCOMOTIVE NO",
  //       colSpan: 1,
  //       leftAlign: true,
  //       topAlign: true,
  //       rowSpan: 1,
  //       className: "tbl-text-normal",
  //       accessor: "locoNo",
  //     },
  //   ],
  // },
  {
    heights: { header1: "50px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "INSPECTION CARRIER",
        colSpan: 1,
        leftAlign: true,
        topAlign: true,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "InspectionCarrier",
      },
    ],
  },
  {
    heights: { header1: "50px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "INSPECTION LOCATION",
        colSpan: 1,
        leftAlign: true,
        topAlign: true,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "InspectionLocation",
      },
    ],
  },
  {
    heights: { header1: "50px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "INSPECTION DATE",
        colSpan: 1,
        leftAlign: true,
        topAlign: true,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "InspectionDate",
      },
    ],
  },
  {
    heights: { header1: "20px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "MOVEMENT RESTRICTIONS",
        colSpan: 1,
        // leftAlign: true,
        topAlign: true,
        isTitleOnly: true,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "",
      },
    ],
  },
  {
    heights: { header1: "50px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "MAXIMUM SPEED",
        colSpan: 1,
        leftAlign: true,
        topAlign: true,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "maxSpeed",
      },
    ],
  },
  {
    heights: { header1: "50px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "OTHER",
        colSpan: 1,
        leftAlign: true,
        topAlign: true,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "others",
      },
    ],
  },
  {
    heights: { header1: "50px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "REPAIR DESTINATION",
        colSpan: 1,
        leftAlign: true,
        topAlign: true,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "repDestination",
      },
    ],
  },
  {
    heights: { header1: "50px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "NATURE OF DEFECT",
        colSpan: 1,
        leftAlign: true,
        topAlign: true,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "natureOfDef",
      },
    ],
  },

  {
    heights: { header1: "50px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "INSPECTED BY (Signature)",
        colSpan: 1,
        leftAlign: true,
        topAlign: true,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "inspectedBy",
        // Signature: true,
        formatter: (data) => {
          let path = getServerEndpoint() + "applicationresources" + "/";
          return data && <img src={path + data} alt="Image not found!" style={{ width: "35%" }} />;
        },
      },
    ],
  },
];
export const ShowTagImage = {
  heights: { header1: "50px" },
  classes: { header2: "" },
  inlineData: true,
  columns: [
    {
      title: "PICTURE OF NON-COMPLIANT LOCOMOTIVE TAG",
      colSpan: 1,
      leftAlign: true,
      topAlign: true,
      rowSpan: 1,
      className: "tbl-text-normal",
      accessor: "tagPic",
      Signature: true,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/NonCompliantLocomotiveReport/Schema.jsx